import { IconButton, Switch } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import ConfirmDeleteModal from "components/ConfirmDeleteModal";
import GKClientDataGrid from "components/GKClientDataGrid";
import useToast from "hooks/useToast";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import { useState } from "react";
import { MdDelete } from "react-icons/md";
import accessBoardService from "servies/accessBoard";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";

function AdminAccessBoard() {
  const toast = useToast();

  const queryClient = useQueryClient();

  const [confirmationModal, setConfirmationModal] = useState(false);

  const [selectedClientId, setSelectedClientId] = useState(null);

  const {
    state: { currentUser },
  } = useAppContext();

  // const isDisabled = currentUser?.phone === "9911223344";

  const {
    data: accessList,
    isRefetching,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [QueryKeys.ACCESS_LIST],
    queryFn: async () => {
      const response = await accessBoardService.getAccessList();
      if (response.status !== 200) {
        toast.show("error", "Failed to fetch access list");
      }
      return response.data;
    },
  });

  const { mutate: deleteClient } = useMutation({
    mutationKey: ["DELETE_CLIENT"],
    mutationFn: (clientId) =>
      axiosInstance.delete(`/super_admin/${clientId}/delete-user/`),
    onSuccess: () => {
      refetch();
    },
  });

  const columns = [
    { field: "name", flex: 1, headerName: "User Name" },
    {
      headerName: "User Phone",
      flex: 1,
      field: "phone",
    },
    {
      headerName: "User Email",
      flex: 1,
      field: "email",
    },
    {
      headerName: "Is Active",
      flex: 1,
      field: "phone",
    },
    {
      headerName: "Is Active",
      flex: 1,
      field: "isActive",
      renderCell: (item) => (item?.row?.isActive ? "Yes" : "No"),
    },
    {
      headerName: "User Role",
      flex: 1,
      field: "userRole",
    },
    {
      headerName: "Is Verified",
      flex: 1,
      field: "isVerified",
      renderCell: (item) => (item?.row?.isVerified ? "Yes" : "No"),
    },
    {
      headerName: "Grant Access",
      flex: 1,
      field: "grantAccess",
      align: "right",
      headerAlign: "right",
      renderCell: (item) => (
        <Switch
          checked={item?.row?.isActive && item?.row?.isVerified}
          onChange={async (value) => {
            const response = await accessBoardService.grantAccess({
              userPhoneNumber: item?.row?.phone,
              hasAccess: value.target.checked,
            });
            if (response.status !== 200) {
              toast.show("error", "Failed to grant access");
            }
            toast.show(
              "success",
              `Access ${value ? "granted" : "revoked"} successfully`
            );
            queryClient.invalidateQueries([QueryKeys.ACCESS_LIST]);
          }}
        />
      ),
    },
    currentUser.phone === "7016333333" && {
      headerName: "Delete User",
      flex: 1,
      field: "deleteClient",
      align: "right",
      headerAlign: "right",
      renderCell: (item) => (
        <IconButton
          color="error"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedClientId(item?.row?.id);
            setConfirmationModal(true);
          }}
        >
          <MdDelete />
        </IconButton>
      ),
    },
  ];

  return (
    <DashboardLayout
      title="Admin Access Board"
      breadcrumbs={[
        {
          name: "Admin Access Board",
          path: "/app/admin-access-board",
        },
      ]}
    >
      <GKClientDataGrid
        columns={columns}
        rows={accessList || []}
        loading={isRefetching || isLoading}
      />
      {confirmationModal && (
        <ConfirmDeleteModal
          open={confirmationModal}
          setOpen={setConfirmationModal}
          onDelete={() => deleteClient(selectedClientId)}
          title="Delete User"
          isDelete
        />
      )}
    </DashboardLayout>
  );
}

export default AdminAccessBoard;
